import { useState } from 'react';
import { login, confirmNewPassword } from '../auth';

export default function LoginPage({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState('signIn'); // 'signIn' | 'newPassword'
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { isSignedIn, nextStep } = await login(username.trim(), password);
      if (isSignedIn) {
        onSuccess?.();
      } else if (nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        setStep('newPassword');
      } else {
        setError('Unexpected sign-in state. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Incorrect username or password.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { isSignedIn } = await confirmNewPassword(newPassword);
      if (isSignedIn) onSuccess?.();
    } catch (err) {
      setError(err.message || 'Could not set new password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <span className="login-brand__mark">p</span>
          <span className="login-brand__name">
            Puro
            <span className="login-brand__pulse" aria-hidden="true"></span>
          </span>
        </div>
        <p className="login-subtitle">
          {step === 'newPassword' ? 'Set a new password' : 'Demo access'}
        </p>

        {step === 'signIn' ? (
          <form className="login-form" onSubmit={handleSignIn}>
            <label className="login-field">
              <span>Email</span>
              <input
                type="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="email"
                autoFocus
                spellCheck={false}
              />
            </label>
            <label className="login-field">
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </label>

            {error && <div className="login-error">{error}</div>}

            <button
              type="submit"
              className="login-submit"
              disabled={submitting || !username || !password}
            >
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        ) : (
          <form className="login-form" onSubmit={handleNewPassword}>
            <p className="login-field" style={{ fontSize: '0.85rem', opacity: 0.7, margin: '0 0 1rem' }}>
              This is your first sign-in. Please set a permanent password.
            </p>
            <label className="login-field">
              <span>New password</span>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                autoFocus
              />
            </label>

            {error && <div className="login-error">{error}</div>}

            <button
              type="submit"
              className="login-submit"
              disabled={submitting || !newPassword}
            >
              {submitting ? 'Setting password…' : 'Set password & sign in'}
            </button>
          </form>
        )}

        <p className="login-disclaimer">
          This is a prototype environment for internal review. Not real financial advice.
        </p>
      </div>
    </div>
  );
}
